import React, { useState, useEffect, useRef, useCallback } from 'react';
import { get, set } from 'idb-keyval';
import { Navigate, NavLink, useParams, useSearchParams } from "react-router-dom";
import moment from 'moment';
import axios from 'axios';
import styled from 'styled-components';
import { toast } from 'react-toastify';
// import ContextMenu from '@ihatecode/react-context-menu';
// import '@ihatecode/react-context-menu/lib/style.css';
import LoggedLayout from "layouts/LoggedLayout";
import PopupLayout from "layouts/PopupLayout";
import TrSkeleton from "components/TrSkeleton";
import { getCommunity } from 'helpers/community';
import { getRouterBasename } from 'helpers/config';
import { formatNumber, jsonToArray, openPopupWindow } from 'helpers/generic';
import { getFromSession } from 'helpers/session';
import ReconciliationModal from './ReconciliationModal';
import CounterPartsModal from './CounterPartsModal';
import AddManualMovementModal from './add-manual-movement-modal';
import Instructions from './Instructions';
import Table2Pdf from 'components/Table2Pdf';
import ActionsContextMenu from 'components/ActionsContextMenu';
import { authUserPermission } from 'helpers/community';

const Table = styled.table`

	td {
		padding: 2px 5px;
		font-size: 13px;

		.user {
			font-size: 8px;
			line-height: 8px;
		}

		.badge {
			padding: 0.2em 0.45em;
			cursor: pointer;

			&:hover {
				box-shadow: 0px 0px 5px white;
			}
		}

		&.red, .red {
			color: red !important;
			font-weight: bold;
		}

		&.green, .green {
			color: green !important;
			font-weight: bold;
		}

		&.reconciliation-btn-wrapper {
			vertical-align: middle;
			width: 35px;
			min-width: 35px;
			max-width: 35px;

			button {
				&:hover {
					transform: scale(1.2);
				}

				&:active {
					transform: scale(1.3);
					color: var(--bs-secondary);
				}
			}
		}
	}

	tr {
		&:first-of-type {
			border-top-color: transparent;
		}

		&:last-of-type {
			border-bottom-color: transparent;
		}
		
		& > th:first-of-type,
		& > td:first-of-type {
			border-left-color: transparent;
		}

		& > th:last-of-type,
		& > td:last-of-type {
			border-right-color: transparent;
		}

		& > th,
		& > td {
			&:nth-child(1),
			&:nth-child(6) {
				min-width: 90px;
				max-width: 90px;
			}

			&:nth-child(2),
			&:nth-child(7) {
				min-width: 300px;
			}
		}

		&.left{
			&:hover {
				td {
					&:nth-child(1),
					&:nth-child(2),
					&:nth-child(3),
					&:nth-child(4) {
						background-color: var(--bs-gray-400);
						cursor: pointer;
					}
				}
			}

			&.selected {
				td {
					&:nth-child(1),
					&:nth-child(2),
					&:nth-child(3),
					&:nth-child(4) {
						background-color: var(--bs-success);
						cursor: pointer;
					}
				}
			}
		}

		&.right {
			&:hover {
				td {
					&:nth-child(6),
					&:nth-child(7),
					&:nth-child(8) {
						background-color: var(--bs-gray-400);
						cursor: pointer;
					}
				}
			}

			&.selected {
				td {
					&:nth-child(6),
					&:nth-child(7),
					&:nth-child(8) {
						background-color: var(--bs-success);
						cursor: pointer;
					}
				}
			}

			.small-text {
				margin: 3px 0;
				font-size: 10px;
				line-height: 100%;
			}
		}

		&.reconciliated {
			position: relative; // Lo he quitado de TD y lo he puesto aquí para que funcione .providerinvoice-counterparts-amount

			td {
				background: rgba(var(--bs-primary-rgb), 0.3);
				/* position: relative; */ // Espero que no reviente nada

				.reconciliations {
					display: flex;
					flex-direction: column;
					width: 100%;
					height: 100%;

					& > div {
						min-height: 50%;
						line-height: 120%;
						padding: 2px 5px;
						border-bottom: 1px solid var(--bs-gray-200);

						&:last-of-type {
							border-bottom: 1px solid transparent;
						}
					}

					.providerinvoice-counterparts {
						padding-left: 18px;
						font-size: 9px;
						line-height: 100%;

						div {
							&:first-of-type {
								margin-top: 5px;
							}

							&:not(:last-of-type) {
								margin-bottom: 6px;
							}

							.providerinvoice-counterparts-amount {
								position: absolute;
								right: 5px;
								transform: translateY(-100%);
							}
						}
					}

					.receiptrefund-parent {
						padding-left: 5px;
						font-size: 9px;
						line-height: 100%;
						margin-top: 5px;
						color: var(--bs-red);
					}

					.small-text {
						margin: 3px 0;
						font-size: 10px;
						line-height: 100%;
					}
				}
			}
		}

		&.partial {
			td {
				background-color: rgba(var(--bs-indigo-rgb), 0.4);

				&:nth-child(6),
				&:nth-child(7),
				&:nth-child(8) {
					cursor: pointer;

				}
			}

			&.partial_selected {
				td {
					&:nth-child(6),
					&:nth-child(7),
					&:nth-child(8) {
						background-color: var(--bs-success);
						cursor: pointer;
					}
				}
			}
		}

		&.hidden {
			display: none;
		}
	}

	th,td {
		user-select: none;

		&:nth-child(1),
		&:nth-child(6) {
			max-width: 100px;
		}

		&:nth-child(2),
		&:nth-child(7) {
			max-width: 300px;
		}

		&:nth-child(3),
		&:nth-child(8) {
			max-width: 150px;
			text-align: right;
		}

		&:nth-child(4) {
			text-align: right;
		}

		&:nth-child(5) {
			/* width: 50px; */
			background: var(--bs-gray-200);
		}
	}
`;

const ButtonReconciliation = styled.button`
	position: fixed;
	display: flex;
	align-items: center;
	bottom: 20px;
	left: 50%;
	width: 250px;
	margin-left: -125px;
	z-index: 99;
	color: white;
	font-size: 16px;
	line-height: 18px;
	text-transform: uppercase;
	box-shadow: 1px 1px 10px rgba(0,0,0,0.2);
`;

const CardHeader = styled.div`
	position: sticky;
	top: ${props => props.top}px;
	z-index: 3;

	#dates-selector {

		input[type="date"] {
			border-top: 1px solid var(--bs-gray-200);
			border-bottom: 1px solid var(--bs-gray-200);
			border-left: 1px solid var(--bs-gray-200);
		}

		button {
			border-color: var(--bs-gray-200);
		}
	}
`;

const sortMovementsByDate = (movements = {}) => {
	const sorted = {};
	Object.keys(movements)
		.sort((a, b) => new Date(b) - new Date(a))
		.forEach((date) => {
			sorted[date] = movements[date];
		});
	return sorted;
};

const normalizeDayList = (list) => {
	if (!Array.isArray(list)) return [];
	return [...list].sort((a, b) => ((b?.id ?? 0) - (a?.id ?? 0)));
};

const buildDateRange = (startDate, endDate) => {
	if (!startDate || !endDate) return [];
	const from = moment(startDate, 'YYYY-MM-DD');
	const to = moment(endDate, 'YYYY-MM-DD');
	if (!from.isValid() || !to.isValid() || from.isAfter(to)) return [];
	const dates = [];
	const current = from.clone();
	while (!current.isAfter(to)) {
		dates.push(current.format('YYYY-MM-DD'));
		current.add(1, 'day');
	}
	return dates;
};

const serializeDayData = (data) => JSON.stringify(Array.isArray(data) ? data : []);

const chunkArray = (list, chunkSize = 1) => {
	if (!Array.isArray(list) || chunkSize <= 0) return [];
	const chunks = [];
	for (let index = 0; index < list.length; index += chunkSize) {
		chunks.push(list.slice(index, index + chunkSize));
	}
	return chunks;
};

let axiosCancelToken = null;

let switchToPreventMultipleRefreshingAtSameTime = false;

let parentWindowProxyCallback = window.opener?.PopupProxyCallback;

export default function BankReconciliationMovements() {
	let community = getCommunity();
	let { id } = useParams();
	
	const [queryParams] = useSearchParams();
	const popup = queryParams.get('popup') === 'true';

	const tableRef = useRef(null);
	const contextMenuBankMovementRef = useRef(null);
	const runIdRef = useRef(0);
	const cachedDayStringsRef = useRef(new Map());
	const activeMovementsRequestsRef = useRef(0);
 
	let [forceReload, setForceReload] = useState(null);
	let [cacheVersion, setCacheVersion] = useState(0);
	let [treasury, setTreasury] = useState(undefined);
	let [movements, setMovements] = useState({});
	let [reconciliationModalOpened, setReconciliationModalOpened] = useState(false);
	let [counterPartModalOpened, setCounterPartModalOpened] = useState(false);
	let [addManualMovementModalOpened, setAddManualMovementModalOpened] = useState(false);
	let [selectedMovements, setSelectedMovements] = useState([]);

	const getNavbarFiscalYearRange = () => {
		const stored = getFromSession('navbar-fiscalyear');
		const year = stored != null ? Number(stored) : null;
		if ( !year ) return null;
		return {
			from: moment(`${year}-01-01`).format('YYYY-MM-DD'),
			to: moment(`${year}-12-31`).format('YYYY-MM-DD'),
		};
	};

	const initialFyRange = getNavbarFiscalYearRange();
	let [dateFrom, _setDateFrom] = useState(initialFyRange?.from ?? moment().startOf('year').format('YYYY-MM-DD'));
	let dateFromRef = useRef(dateFrom);
	let setDateFrom = (val) => {
		_setDateFrom(val);
		dateFromRef.current = val;
	}
	let [dateTo, _setDateTo] = useState(initialFyRange?.to ?? moment().endOf('year').format('YYYY-MM-DD'));
	let dateToRef = useRef(dateTo);
	let setDateTo = (val) => {
		_setDateTo(val);
		dateToRef.current = val;
	}

	let [loading, setLoading] = useState(false);
	let [loadingMovements, setLoadingMovements] = useState(false);
	let [showNoReconciliatedOnly, setShowNoReconciliatedOnly] = useState(false);
	let [hidePendingReceipts, setHidePendingReceipts] = useState(false);
	let [expensesIncomesFilter, setExpensesincomesFilter] = useState('all');
	let [skeletonRows, setSkeletonRows] = useState(5);
	let [search, setSearch] = useState('');

	let [stickyHeaderTop, setStickyHeaderTop] = useState(0);
	let [filtersReady, setFiltersReady] = useState(false);

	const beginMovementsLoading = useCallback(() => {
		activeMovementsRequestsRef.current += 1;
		if (activeMovementsRequestsRef.current === 1) {
			setLoadingMovements(true);
		}
	}, []);

	const endMovementsLoading = useCallback(() => {
		activeMovementsRequestsRef.current = Math.max(0, activeMovementsRequestsRef.current - 1);
		if (activeMovementsRequestsRef.current === 0) {
			setLoadingMovements(false);
		}
	}, []);

	const getDayCacheKey = useCallback((date) => {
		if (!community?.id || !id || !treasury?.id || !date) return null;
		return `${community.id}-${id}-${treasury.id}-${date}`;
	}, [community?.id, id, treasury?.id]);

	const getFiltersCacheKey = useCallback(() => {
		if (!community?.id || !id) return null;
		return `bankreconciliation-filters-${community.id}-${id}`;
	}, [community?.id, id]);

	const persistFilters = useCallback(async (filters) => {
		const filtersKey = getFiltersCacheKey();
		if (!filtersKey) return;
		try {
			await set(filtersKey, filters);
		} catch (e) {
			// Ignore IndexedDB errors
		}
	}, [getFiltersCacheKey]);

	const saveDayToCache = useCallback(async (date, data) => {
		const cacheKey = getDayCacheKey(date);
		if (!cacheKey) return;
		const normalized = normalizeDayList(data);
		const serialized = serializeDayData(normalized);
		if (cachedDayStringsRef.current.get(cacheKey) === serialized) return;
		try {
			await set(cacheKey, { data: normalized, updatedAt: Date.now() });
		} catch (e) {
			// Ignore IndexedDB errors
		}
		cachedDayStringsRef.current.set(cacheKey, serialized);
	}, [getDayCacheKey]);

	const applyMovementsUpdate = useCallback((movementsObj) => {
		if (!movementsObj) return;
		const entries = Object.entries(movementsObj);
		if (!entries.length) return;

		setMovements((prev) => {
			const merged = { ...(prev || {}) };
			entries.forEach(([date, list]) => {
				merged[date] = normalizeDayList(list);
			});
			return sortMovementsByDate(merged);
		});

		entries.forEach(([date, list]) => {
			saveDayToCache(date, list);
		});
	}, [saveDayToCache]);

	useEffect(() => {
		let top = document.querySelector('.page-title')?.getBoundingClientRect().bottom;
		setStickyHeaderTop(popup ? 0 : top);
	}, [popup]);

	useEffect(() => {
		axiosCancelToken = axios.CancelToken.source();

		// No se escucha 'fiscalYearChanged' a propósito: al cambiar de ejercicio en la
		// cabecera se mantienen las fechas del filtro y los movimientos en pantalla.

		return () => {
			axiosCancelToken.cancel();
		};
	}, []);

	useEffect(() => {
		setFiltersReady(false);
	}, [community?.id, id]);

	useEffect(() => {
		if (!community?.id || !id) return;
		let cancelled = false;

		const loadFilters = async () => {
			const filtersKey = getFiltersCacheKey();
			if (!filtersKey) {
				if (!cancelled) {
					setFiltersReady(true);
				}
				return;
			}

			try {
				const cachedFilters = await get(filtersKey);
				if (cancelled) return;
				const fyRange = getNavbarFiscalYearRange();
				if (cachedFilters?.dateFrom && cachedFilters?.dateTo) {
					// Si hay cache, respetarlo solo si encaja dentro del FY seleccionado.
					// Si no, sobreescribir con el rango del FY.
					const fits = !fyRange || (cachedFilters.dateFrom >= fyRange.from && cachedFilters.dateTo <= fyRange.to);
					if (fits) {
						setDateFrom(cachedFilters.dateFrom);
						setDateTo(cachedFilters.dateTo);
					} else {
						setDateFrom(fyRange.from);
						setDateTo(fyRange.to);
						await persistFilters({ dateFrom: fyRange.from, dateTo: fyRange.to });
					}
				} else {
					await persistFilters({
						dateFrom: dateFromRef.current,
						dateTo: dateToRef.current,
					});
				}
			} catch (e) {
				if (!cancelled) {
					await persistFilters({
						dateFrom: dateFromRef.current,
						dateTo: dateToRef.current,
					});
				}
			} finally {
				if (!cancelled) {
					setFiltersReady(true);
				}
			}
		};

		loadFilters();

		return () => {
			cancelled = true;
		};
	}, [community?.id, id, getFiltersCacheKey, persistFilters]);

	useEffect(() => {
		if (!community?.id || !id) return;
		if (!filtersReady) return;
		persistFilters({
			dateFrom: dateFromRef.current,
			dateTo: dateToRef.current,
		});
	}, [community?.id, id, dateFrom, dateTo, persistFilters, filtersReady]);

	useEffect(() => {
		if (!community?.id || !id || !treasury?.id) return;
		if (!filtersReady) return;
		let cancelled = false;

		const loadCachedMovements = async () => {
			const dates = buildDateRange(dateFromRef.current, dateToRef.current);
			if (cancelled) return;
			if (!dates.length) {
				setMovements({});
				cachedDayStringsRef.current = new Map();
				setCacheVersion((prev) => prev + 1);
				return;
			}

			const nextCacheStrings = new Map();

			try {
				const entries = await Promise.all(dates.map(async (date) => {
					const cacheKey = getDayCacheKey(date);
					if (!cacheKey) return { date, cacheKey: null, data: [] };
					try {
						const cached = await get(cacheKey);
						return { date, cacheKey, data: cached?.data ?? [] };
					} catch (e) {
						return { date, cacheKey, data: [] };
					}
				}));

				if (cancelled) return;

				const aggregated = {};
				entries.forEach(({ date, cacheKey, data }) => {
					if (!cacheKey) return;
					const normalized = normalizeDayList(data);
					nextCacheStrings.set(cacheKey, serializeDayData(normalized));
					if (normalized.length) {
						aggregated[date] = normalized;
					}
				});

				cachedDayStringsRef.current = nextCacheStrings;
				setMovements(Object.keys(aggregated).length ? sortMovementsByDate(aggregated) : {});
			} catch (e) {
				if (!cancelled) {
					cachedDayStringsRef.current = nextCacheStrings;
					setMovements({});
				}
			} finally {
				if (!cancelled) {
					setCacheVersion((prev) => prev + 1);
				}
			}
		};

		loadCachedMovements();

		return () => {
			cancelled = true;
		};
	}, [community?.id, id, treasury?.id, forceReload, getDayCacheKey, filtersReady]);

	useEffect(() => {
		const getTreasury = async () => {
			setLoading(true);
			await axios.get('/api/manager/treasury/get/' + id, {
				params: {
					community_id: community?.id,
				},
				cancelToken: axiosCancelToken.token
			}).then((response) => {
				setTreasury({...response.data});
			}).catch((error) => {
				if ( axios.isCancel(error) ) return;
			});	
			setLoading(false);
		}
		getTreasury();
	}, [id, community?.id]);

	useEffect(() => {
		if (!community?.id || !id || !treasury?.id) return;
		if (!cacheVersion) return;
		if (!filtersReady) return;

		axiosCancelToken = axios.CancelToken.source();
		runIdRef.current += 1;
		const currentRunId = runIdRef.current;

		const getMovements = async (runId) => {
			const startTime = new Date();
			console.log(
				`getMovements INICIO: ${startTime.toLocaleDateString()} ${startTime.toLocaleTimeString()}`
			);

			beginMovementsLoading();
			setLoading(true);

			let shouldLogDuration = true;

			try {
				const daysResponse = await axios.get(
					`/api/manager/bank-reconciliation/${id}/days-with-movements`,
					{
						params: {
							community_id: community?.id,
							date_from: dateFromRef.current,
							date_to: dateToRef.current,
						},
						cancelToken: axiosCancelToken.token,
					}
				);
				const daysWithMovements = daysResponse.data?.dates || [];

				const daysSet = new Set(daysWithMovements);
				const removedDays = [];
				setMovements((prev) => {
					if (!prev) return {};
					const updated = {};
					Object.keys(prev).forEach((day) => {
						if (daysSet.has(day)) {
							updated[day] = prev[day];
						} else {
							removedDays.push(day);
						}
					});
					return sortMovementsByDate(updated);
				});
				removedDays.forEach((day) => {
					saveDayToCache(day, []);
				});

				const batches = chunkArray(daysWithMovements, 5);
				let aborted = false;
				for (const batch of batches) {
					if (runIdRef.current !== runId) {
						aborted = true;
						break;
					}

					const results = await Promise.all(
						batch.map(async (date) => {
							try {
								const response = await axios.get(
									`/api/manager/bank-reconciliation/${id}/movements-list/${date}`,
									{
										params: {
											community_id: community?.id,
										},
										cancelToken: axiosCancelToken.token,
									}
								);
								return { date, movementsObj: response.data || {} };
							} catch (error) {
								return { date, error };
							}
						})
					);

					if (runIdRef.current !== runId) {
						aborted = true;
						break;
					}

					let hadSuccess = false;
					for (const { date, movementsObj, error } of results) {
						if (error) {
							if (axios.isCancel(error)) {
								aborted = true;
								break;
							}
							continue;
						}

						if (movementsObj && Object.keys(movementsObj).length > 0) {
							applyMovementsUpdate(movementsObj);
						} else {
							applyMovementsUpdate({ [date]: [] });
						}
						hadSuccess = true;
					}

					if (aborted) {
						break;
					}

					if (hadSuccess) {
						setSkeletonRows(5);
					}
				}

				if (aborted) {
					shouldLogDuration = false;
					return;
				}
			} catch (error) {
				if (axios.isCancel(error)) {
					shouldLogDuration = false;
					return;
				}

				shouldLogDuration = false;
				toast.error('Error al obtener los días con movimientos');
				return;
			} finally {
				setLoading(false);
				endMovementsLoading();

				if (shouldLogDuration) {
					const endTime = new Date();
					console.log(
						`getMovements FIN: ${endTime.toLocaleDateString()} ${endTime.toLocaleTimeString()}`
					);
					const durationMs = endTime - startTime;
					const durationSec = Math.floor((durationMs / 1000) % 60);
					const durationMin = Math.floor((durationMs / (1000 * 60)) % 60);
					const durationHr = Math.floor(durationMs / (1000 * 60 * 60));
					console.log(
						`Duración total: ${durationHr}h ${durationMin}m ${durationSec}s`
					);
				}
			}
		};
		getMovements(currentRunId);

		return () => {
			axiosCancelToken.cancel();
		};
	}, [id, community?.id, treasury?.id, cacheVersion, applyMovementsUpdate, saveDayToCache, filtersReady, beginMovementsLoading, endMovementsLoading]);

	// Execute height fix
	useEffect(() => {
		setTimeout(() => {
			let elementsToFixHeight = document.querySelectorAll('[data-heightfixto]');
			elementsToFixHeight.forEach((el) => {
				let idx = el.dataset.heightfixto;

				// Find the FROM element
				let fromEl = document.querySelector('[data-heightfixfrom="' + idx + '"]');
				if ( !fromEl ) return;

				el.style.height = fromEl.offsetHeight + 'px';
			});
		}, 100);
	}, [movements]);

	useEffect(() => {
		window.onbeforeunload = () => {
			parentWindowProxyCallback({type: 'refreshCounterPartsAndPayments'});
		};
	}, []);

	const applyDates = () => {
		setMovements(undefined);
		setForceReload(Math.random());
	}

	const addYears = (qty) => {
		let newDateTo = moment(dateTo).add(qty, 'years').format('YYYY-MM-DD');
		let newDateFrom = moment(dateFrom).add(qty, 'years').format('YYYY-MM-DD');

		setDateFrom(newDateFrom);
		setDateTo(newDateTo);
	}

	const getDateRange = (range) => {
		let dateFrom = null;
		let dateTo = null;
		
		switch(range) {
			case 'thismonth':
				dateFrom = moment().startOf('month').format('YYYY-MM-DD');
				dateTo = moment().endOf('month').format('YYYY-MM-DD');
			break;

			case 'lastmonth':
				dateFrom = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
				dateTo = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
			break;

			case 'thisyear':
				dateFrom = moment().startOf('year').format('YYYY-MM-DD');
				dateTo = moment().endOf('year').format('YYYY-MM-DD');
			break;

			case 'lastyear':
				dateFrom = moment().subtract(1, 'years').startOf('year').format('YYYY-MM-DD');
				dateTo = moment().subtract(1, 'years').endOf('year').format('YYYY-MM-DD');
			break;
			default: 
		}

		return {dateFrom, dateTo};;
	}

	const setDates = (e, range) => {
		e.preventDefault();

		let {dateFrom, dateTo} = getDateRange(range);
		
		setDateFrom(dateFrom);
		setDateTo(dateTo);
	}

	const selectMovement = (movement) => {
		let newSelectedMovements = [...selectedMovements];
		let selectedIdx = newSelectedMovements.findIndex((el) => el.class === movement.class && el.id === movement.id);
		if ( selectedIdx !== -1 ) newSelectedMovements.splice(selectedIdx, 1);
		else newSelectedMovements.push(movement);
		setSelectedMovements(newSelectedMovements); 
	}

	const removeReconciliation = (value) => {
		let c = window.confirm('¿Seguro que quieres desconciliar estos movimientos?');
		if ( !c ) return;

		let id = value.reconciliation[0].bank_reconciliation_id;

		axios.post('/api/manager/bank-reconciliation/delete/' + id, {
			community_id: getCommunity()?.id,
		}, {
			cancelToken: axiosCancelToken.token
		}).then((response) => {
			toast.warning('Movimientos desconciliados');

			// Get dates to reupdate
			let dates = [];
			dates.push(value.date);
			value.reconciliation?.forEach(el => {
				if ( el.entity?.date ) dates.push(el.entity.date);
			});

			// Check if exists other bankmovements to the same bankreconciliation and get date
			let bankReconciliationId = value.reconciliation[0].bank_reconciliation_id;
			Object.keys(movements).forEach((key) => {
				movements[key].forEach((el) => {
					if ( el.class === 'App\\Models\\BankMovement' && el.reconciliation && el.reconciliation.length > 0 && el.reconciliation[0].bank_reconciliation_id === bankReconciliationId ) {
						if ( el.date ) dates.push(el.date);
						if (el.reconciliation[0].entity?.date) dates.push(el.reconciliation[0].entity.date);
					}
				});
			});

			// Remove duplicated dates
			dates = [...new Set(dates)];

			// Reupdate
			refreshRowsFromDates(dates);

			// setForceReload(Math.random());
		}).catch((error) => {
			if ( axios.isCancel(error) ) return;
			toast.error('Ha ocurrido un error al guardar');
		});	
	}

	const showReconciliationButton = (() => {
		let left = 0;
		let right = 0;

		let onlyReceiptsSelected = selectedMovements.filter(el => el.class.indexOf('BankMovement') === -1).every(el => el.class.indexOf('Receipt') !== -1);
		let onlyBankRemittancesSelected = selectedMovements.filter(el => el.class.indexOf('BankMovement') === -1).every(el => el.class.indexOf('BankRemittance') !== -1);
		let receiptsReunificateFirstPropertyId = null;
		let receiptsToReunificate = 0;
		let partialReceiptsSelected = false;
		let receiptsFromDifferentPropertiesButSameOwner = 0;
		let receiptsFromDifferentPropertiesButSameOwnerIds = [];
		let onlyProviderInvoicesSelected = selectedMovements.filter(el => el.class.indexOf('BankMovement') === -1).every(el => el.class.indexOf('ProviderInvoice') !== -1);
		let providerInvoicesFromSameProviderId = null;
		let partialInvoicesSelected = selectedMovements.filter(el => el.class.indexOf('BankMovement') === -1).some(el => el.class.indexOf('ProviderInvoice') !== -1 && el.partial);

		selectedMovements.forEach((el) => {
			if ( el.class === 'App\\Models\\BankMovement' ) left += 1;
			else right += 1;

			if ( el.class === 'App\\Models\\Receipt' ) {
				if ( el.partial ) partialReceiptsSelected = true;

				// Checks for reunification receipts
				if ( receiptsReunificateFirstPropertyId && receiptsReunificateFirstPropertyId === el.property_id ) receiptsToReunificate++;
				else receiptsToReunificate = 0;
				if ( !receiptsReunificateFirstPropertyId ) receiptsReunificateFirstPropertyId = el.property_id;

				// Checks for multiple receipts selected and different properties
				if ( receiptsFromDifferentPropertiesButSameOwnerIds.length === 0 ) {
					receiptsFromDifferentPropertiesButSameOwnerIds = [...el.owners_ids];
					receiptsFromDifferentPropertiesButSameOwner++;
				} else {
					let hasOwner = el.owners_ids?.some(v => receiptsFromDifferentPropertiesButSameOwnerIds.includes(v));
					if ( hasOwner ) receiptsFromDifferentPropertiesButSameOwner++;
				}
			}

			if ( el.class === 'App\\Models\\ProviderInvoice' ) {
				if ( !providerInvoicesFromSameProviderId ) providerInvoicesFromSameProviderId = el.provider_id;
				else if ( providerInvoicesFromSameProviderId !== el.provider_id ) providerInvoicesFromSameProviderId = null;
			}
		});

		let allReceiptsWithCommonOwner = receiptsFromDifferentPropertiesButSameOwner > 0 && receiptsFromDifferentPropertiesButSameOwner === selectedMovements.filter(el => el.class.indexOf('Receipt') !== -1).length;

		return 	(left === 1 && right === 0) || 
				(left === 1 && right === 1) || 
				(left === 1 && right > 0 && onlyReceiptsSelected && receiptsToReunificate > 0 && !partialReceiptsSelected) || 
				(left === 1 && right > 0 && onlyReceiptsSelected && allReceiptsWithCommonOwner && !partialReceiptsSelected) ||
				(left >= 1 && right === 1 && onlyBankRemittancesSelected) || 
				(left >= 1 && right >= 1 && onlyProviderInvoicesSelected && providerInvoicesFromSameProviderId !== null && !partialInvoicesSelected )
		;
	})();

	const openEntity = async (e, entity, otherData = null) => {
		e.stopPropagation();

		if ( entity.class.indexOf('ProviderInvoice') !== -1 ) {
			const w = openPopupWindow(getRouterBasename() + '/providers-invoices/edit/' + entity.id + '?popup=true&hidden_sections=[delete_button_DISABLED]');
			const intervalId = setInterval(() => {
				if (w.closed) {
					clearInterval(intervalId);
					
					refreshRowsFromDates([entity.date]);
				}
			}, 500); // Comprueba cada 0.5 segundos
		}

		if ( entity.class.indexOf('Receipt') !== -1 ) openPopupWindow(getRouterBasename() + '/receipts/edit/' + entity.id + '?popup=true');
		if ( entity.class.indexOf('BankRemittance') !== -1 ) {
			openPopupWindow(getRouterBasename() + '/bankremittances?popup=true&id=' + entity.id);
		}
		if ( entity.class.indexOf('ClientInvoice') !== -1 ) openPopupWindow(getRouterBasename() + '/clients-invoices/edit/' + entity.id + '?popup=true');
		if ( entity.class.indexOf('EstimateGroupExpense') !== -1 ) {
			if ( otherData.is_deletable ) {
				setCounterPartModalOpened(otherData);
			} else {
				let w = openPopupWindow();
				await axios.get('/api/manager/estimates/get-id-by-groupexpense/' + entity.id, {
					params: {
						community_id: getCommunity()?.id,
					},
					cancelToken: axiosCancelToken.token
				}).then((response) => {
					w.location.href = getRouterBasename() + '/estimates/edit/' + response.data.id + '?popup=true';
				}).catch((error) => {
					if ( axios.isCancel(error) ) return;
					toast.error('Ha ocurrido un error');
				});	
			}
		}
		if ( entity.class.indexOf('Property') !== -1 ) {
			openPopupWindow(getRouterBasename() + '/properties/edit/' + entity.id + '?popup=true');
		}
	}

	const isHiddenBySearchRow = (el) => {
		return search.length > 0 && (
			el.title.toLowerCase().indexOf(search.toLowerCase()) === -1
			&&
			el.amount.toString().indexOf(search) === -1
			&&
			moment(el.date).format('DD-MM-YYYY').indexOf(search) === -1
		);
	}

	const isHiddenByReconciliated = (el) => {
		return showNoReconciliatedOnly && el.reconciliation;
	}

	const isHiddenByPendingReceipt = (el) => {
		if (el.class === 'App\\Models\\Receipt' && hidePendingReceipts) return true;
	}

	const isHiddenByExpensesIncomesFilter = (el) => {
		if ( expensesIncomesFilter === 'expenses' ) return el.amount >= 0;
		if ( expensesIncomesFilter === 'incomes' ) return el.amount < 0;
		return false;
	}

	const refreshRowsFromDates = async (dates) => {
		if (switchToPreventMultipleRefreshingAtSameTime) return;

		const uniqueDates = [...new Set(dates)].filter(Boolean);
		if (!uniqueDates.length) return;

		switchToPreventMultipleRefreshingAtSameTime = true;
		beginMovementsLoading();

		try {
			const batches = chunkArray(uniqueDates, 5);
			let cancelled = false;

			for (const batch of batches) {
				const results = await Promise.all(
					batch.map(async (date) => {
						try {
							const response = await axios.get(
								`/api/manager/bank-reconciliation/${id}/movements-list/${date}`,
								{
									params: {
										community_id: community?.id,
									},
									cancelToken: axiosCancelToken.token,
								}
							);
							return { date, movementsObj: response.data || {} };
						} catch (error) {
							return { date, error };
						}
					})
				);

				for (const { date, movementsObj, error } of results) {
					if (error) {
						if (axios.isCancel(error)) {
							cancelled = true;
							break;
						}
						continue;
					}

					if (movementsObj && Object.keys(movementsObj).length > 0) {
						applyMovementsUpdate(movementsObj);
					} else {
						applyMovementsUpdate({ [date]: [] });
					}
				}

				if (cancelled) {
					break;
				}
			}
		} finally {
			switchToPreventMultipleRefreshingAtSameTime = false;
			endMovementsLoading();
		}
	};

	const onContextMenu = (e, el) => {
		contextMenuBankMovementRef.current = el;
	}

	const openCreateRulePopup = () => {
		openPopupWindow(
			getRouterBasename() + '/bank-reconciliation/rules/add?popup=true' + 
			'&year=' + moment(contextMenuBankMovementRef.current?.date).format('YYYY') +
			'&concept=' + (contextMenuBankMovementRef.current?.concept ?? '')
		);

		contextMenuBankMovementRef.current = null;
	}

	const removeBankMovement = (e, entity) => {
		if (e) {
			e.stopPropagation();
			e.preventDefault();
		}

		let c = window.confirm('¿Seguro que quieres eliminar este movimiento?');
		if ( !c ) return;

		axios.post('/api/manager/bank-reconciliation/remove-manual-bankmovement', {
			community_id: getCommunity()?.id,
			id: entity.id
		}, {
			cancelToken: axiosCancelToken.token
		}).then((response) => {
			toast.warning('Movimiento eliminado');

			// Reupdate
			refreshRowsFromDates([entity.date]);

		}).catch((error) => {
			if ( axios.isCancel(error) ) return;
			toast.error('Ha ocurrido un error al eliminar el movimiento');
		});
	}

	const openPopupWindowFix = (e) => {
		e.preventDefault();
		openPopupWindow(e.currentTarget.href, 'bank-reconciliation-rules');
	}

	if ( !community?.id ) return <Navigate to="/" />;

	const Layout = popup ? PopupLayout : LoggedLayout;

	return (
		<Layout>
			<ActionsContextMenu 
				className="dropdown-menu" 
				disableCopy={true} 
				allowedElements={Array.from(document.querySelectorAll('.context-menu-allowed'))}
			>
				<li><button className="dropdown-item" onClick={() => openCreateRulePopup()}>Crear regla</button></li>	
			</ActionsContextMenu>
				
			<section>
				<div className="page-title">
					<h1>
						Conciliación bancaria para&nbsp;
						<small><i>{ treasury?.name }</i></small>
					</h1>
					
					<div className="ms-auto">
						{ authUserPermission('edit') &&
							<NavLink to={`/bank-reconciliation/rules?popup=true`} onClick={openPopupWindowFix} className="btn btn-sm btn-warning me-3">Abrir reglas</NavLink>
						}

						{!popup &&
							<NavLink to={-1} className="btn btn-sm btn-light ms-auto">Volver</NavLink>
						}
						
						{popup &&
							<NavLink to={-1} onClick={() => window.close()} className="btn btn-sm btn-light ms-auto">Cerrar</NavLink>
						}
					</div>
				</div>

				<div className="page-content">
					<div className="col-md-12">
						<Instructions />
					</div>

					<div className="card border-0 shadow-sm">
						<CardHeader top={stickyHeaderTop} className="card-header bg-white p-3">
							<div className="row">
								<div className="col-md-4 mb-2 mt-2 mb-md-0 mt-md-0">	
									<div className="input-group input-group-sm" id="dates-selector">
										<span className="input-group-text">
											Fechas
										</span>
										<input type="date" className="form-control form-control-sm text-center" placeholder="Desde" value={dateFrom ?? ''} onChange={(e) => setDateFrom(e.target.value)} /*disabled={loading}*/ />
										<input type="date" className="form-control form-control-sm text-center" placeholder="Hasta" value={dateTo ?? ''} onChange={(e) => setDateTo(e.target.value)} /*disabled={loading}*/ />
										<span className="input-group-btn" >
											<button className="btn btn-light dropdown-toggle" /*disabled={loading}*/ type="button" data-bs-toggle="dropdown" aria-expanded="false"></button>
											<ul className="dropdown-menu dropdown-menu-end">
												<li><a className="dropdown-item" href="." onClick={(e) => setDates(e, 'thismonth')}>Este mes</a></li>
												<li><a className="dropdown-item" href="." onClick={(e) => setDates(e, 'lastmonth')}>Mes pasado</a></li>
												<li><a className="dropdown-item" href="." onClick={(e) => setDates(e, 'thisyear')}>Este año</a></li>
												<li><a className="dropdown-item" href="." onClick={(e) => setDates(e, 'lastyear')}>Año pasado</a></li>
											</ul>
										</span>
										<button className="btn btn-sm btn-light" onClick={(e) => addYears(-1)} /*disabled={loading}*/><i className="bi bi-arrow-left"></i></button>
										<button className="btn btn-sm btn-light" onClick={(e) => addYears(1)} /*disabled={loading}*/><i className="bi bi-arrow-right"></i></button>
										<button className="btn btn-sm btn-light" onClick={applyDates} /*disabled={loading}*/>Aplicar</button>
									</div>
								</div>

								<div className="col-md-2 mb-2 mt-2 mb-md-0 mt-md-0">
									<div className="d-flex h-100 align-items-center sbold me-5">Saldo real: { formatNumber(treasury?.real_balance ?? 0, 2) } €</div>
								</div>

								<div className="col-md-1 mb-2 mt-2 mb-md-0 mt-md-0">
								</div>


								<div className="col-md-3 mb-2 mt-2 mb-md-0 mt-md-0">
									<input type="search" className="form-control form-control-sm" style={{minHeight: 'unset'}} placeholder="Buscar" onChange={(e) => setSearch(e.target.value)} />
								</div>
								<div className="col-md-2 mb-2 mt-2 mb-md-0 mt-md-0">
									<select value={expensesIncomesFilter} onChange={(e) => setExpensesincomesFilter(e.target.value)} className="form-control form-control-sm">
										<option value="all">Mostrar gastos e ingresos</option>
										<option value="expenses">Sólo gastos</option>
										<option value="incomes">Sólo Ingresos</option>
									</select>
								</div>

								<div className="col-md-12 mt-3"></div>

								
								<div className="col-md-2 mb-2 mt-2 mb-md-0 mt-md-0">
									{loadingMovements && (
										<div className="d-flex align-items-center h-100">
											<span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
											<span>Cargando movimientos...</span>
										</div>
									)}

									{(!loadingMovements && treasury?.type === 'cash') && (
										<button className="btn btn-sm btn-primary text-white" onClick={() => setAddManualMovementModalOpened(true)}>Añadir movimiento bancario</button>
									)}
								</div>

								<div className="col-md-6 mb-2 mt-2 mb-md-0 mt-md-0">
									
								</div>

								<div className="col-md-4 mb-2 mt-2 mb-md-0 mt-md-0 text-end">
									<div className="d-flex align-items-center justify-content-between">
										<div className="form-check form-switch mb-0 h-100 d-inline-flex align-items-center">
											<input className="form-check-input mb-1 me-2" type="checkbox" checked={hidePendingReceipts} onChange={(e) => setHidePendingReceipts(e.target.checked)} />
											<label className="form-check-label">Ocultar recibos pendientes</label>
										</div>

										<div className="form-check form-switch mb-0 h-100 d-inline-flex align-items-center">
											<input className="form-check-input mb-1 me-2" type="checkbox" checked={showNoReconciliatedOnly} onChange={(e) => setShowNoReconciliatedOnly(e.target.checked)} />
											<label className="form-check-label">Mostrar movimientos sin conciliar</label>
										</div>

										<Table2Pdf 
											tableRef={tableRef}
											pdfName={'conciliacion-bancaria'}
										/>
									</div>
								</div>
							</div>
						</CardHeader>

						<div className="card-body p-0">
							<div className="table-responsive table-responsive-carded">
								<Table className="table table-hover table-sortable table-carded table-bordered table-striped" ref={tableRef}>
									<thead>
										<tr>
											<th>Fecha</th>
											<th>Concepto</th>
											<th>Importe</th>
											<th>Saldo</th>
											<th></th>
											<th>Fecha</th>
											<th>Concepto</th>
											<th>Importe</th>
										</tr>
									</thead>
									<tbody>
										{ (() => {
											const seenEntities = new Set();
											return (movements && Object.keys(movements).length > 0) &&
											jsonToArray(movements).map((movementsRow, idx) => {
												return (
													<React.Fragment key={idx}>
														{jsonToArray(movementsRow.value).map((movement, movementIdx) => {
															let value = movement.value;

															// Dedup: al desconciliar, puede ocurrir un race condition entre
															// refreshRowsFromDates y getMovements (carga en background por batches)
															// que provoque que la misma entidad (factura, recibo, etc.) aparezca
															// duplicada como item independiente en el mismo día o en días distintos.
															// Este Set actúa como red de seguridad visual: si ya se pintó una
															// entidad con el mismo class+id, no se vuelve a pintar.
															if (value.class !== 'App\\Models\\BankMovement') {
																const entityKey = `${value.class}-${value.id}`;
																if (seenEntities.has(entityKey)) return null;
																seenEntities.add(entityKey);
															}

															let position = value.class === 'App\\Models\\BankMovement' ? 'left' : 'right';
															let selected = selectedMovements.findIndex((el) => el.class === value.class && el.id === value.id) !== -1;
															let partial = null;
															let partial_selected = false;
															let cannot_unlink = false;

															if ( movement.value.is_deletable === false ) cannot_unlink = true;

															if ( value.reconciliation ) {
																position = null;

																if ( value.reconciliation.length === 1 && value.reconciliation[0].entity && value.reconciliation[0].entity.partial ) {
																	partial = true;
																	partial_selected = selectedMovements.findIndex((el) => el.class === value.reconciliation[0].entity.class && el.id === value.reconciliation[0].entity.id) !== -1;
																}

																for(let vrIdx in value.reconciliation) {
																	let vrItem = value.reconciliation[vrIdx];
																	if ( vrItem.entity.cannot_unlink ) {
																		cannot_unlink = true;
																		break;
																	}
																}
															}


															// ---- Check if hidden ------------------------------------------------------------------
																let isHidden = isHiddenBySearchRow({
																	title: value.concept,
																	amount: value.amount,
																	date: value.date
																});

																// Check on associated reconciliations
																if ( isHidden && value.reconciliation && value.reconciliation.length > 0 ) {
																	for(let i=0; i<value.reconciliation.length; i++) {
																		let vr = value.reconciliation[i];
																		isHidden = isHiddenBySearchRow({
																			title: vr.entity.concept,
																			amount: vr.entity.amount,
																			date: vr.entity.date
																		});
																		if ( !isHidden ) break;
																	}
																}

																// Check if is hidden by no reconciliated
																if ( !isHidden ) {
																	isHidden = isHiddenByReconciliated(value);
																}

																// Check if is hidden expensesIncomesFilter
																if ( !isHidden ) {
																	isHidden = isHiddenByExpensesIncomesFilter(value);
																}

																// Check if is hidden isHiddenByPendingReceipt
																if ( !isHidden ) {
																	isHidden = isHiddenByPendingReceipt(value);
																}
															//  --------------------------------------------------------------------------------------

															return (
																<tr key={movementIdx} className={(position ? position : '') + ' ' + (selected ? 'selected' : '') + ' ' + (value.reconciliation ? 'reconciliated' : '') + ' ' + (partial ? 'partial' : '') + ' ' + (partial_selected ? 'partial_selected' : '') + ' ' + (isHidden ? 'hidden' : '')}>
																	{ (!value.reconciliation || value.reconciliation.length === 0) ? // Can select to reconciliate
																		<React.Fragment>
																			<td className={position === 'left' ? 'context-menu-allowed' : ''} onClick={(e) => position === 'left' ? selectMovement(movement.value) : e.preventDefault()} onContextMenu={e => position === 'left' ? onContextMenu(e, value) : null}>
																				{ position === 'left' &&
																					moment(value.date).format('DD-MM-YYYY')
																				}
																			</td>
																			<td className={position === 'left' ? 'context-menu-allowed' : ''} onClick={(e) => position === 'left' ? selectMovement(movement.value) : e.preventDefault()} onContextMenu={e => position === 'left' ? onContextMenu(e, value) : null}>
																				{ position === 'left' &&
																					<>
																						{value.is_removable &&
																							<button className="btn btn-sm btn-link text-danger p-0 me-2" onClick={(e) => removeBankMovement(e, value)}><i className="bi bi-trash"></i></button>
																						}
																						{value.concept}
																					</>
																				}
																			</td>
																			<td className={(value.amount < 0 ? 'red' : 'green') + ' ' + (position === 'left' ? 'context-menu-allowed' : '')} onClick={(e) => position === 'left' ? selectMovement(movement.value) : e.preventDefault()} onContextMenu={e => position === 'left' ? onContextMenu(e, value) : null}>
																				{ position === 'left' &&
																					formatNumber(value.amount)
																				}
																			</td>
																		</React.Fragment>
																		: // Is reconciliated
																		<React.Fragment>
																			<td className={'context-menu-allowed'} onContextMenu={e => onContextMenu(e, value)}>
																				{moment(value.date).format('DD-MM-YYYY')}
																				<div className="user">{value.user?.name ?? 'Conciliación automática'}</div>
																			</td>
																			<td className={'context-menu-allowed'} onContextMenu={e => onContextMenu(e, value)}>
																				{value.concept}
																			</td>
																			<td className={(value.amount < 0 ? 'red' : 'green') + ' ' + ('context-menu-allowed')} onContextMenu={e => onContextMenu(e, value)}>{formatNumber(value.amount)}</td>
																		</React.Fragment>
																	}

																	<td className={'bankbalance ' + (value.balance < 0 ? 'red' : 'green')} onClick={(e) => position === 'left' ? selectMovement(movement.value) : e.preventDefault()}>
																		{value.balance !== undefined ? formatNumber(value.balance, 2) : ''}
																	</td>
																	
																	<td className="text-center reconciliation-btn-wrapper">
																		{ (value.reconciliation && value.reconciliation.length > 0 && !cannot_unlink) &&
																			<button className="btn-unstyled" onClick={() => removeReconciliation(value)}><i className="bi bi-arrow-left-right"></i></button>
																		}
																		{ cannot_unlink &&
																			<button className="btn-unstyled pe-none" style={{cursor: 'pointer'}}><i className="bi bi-lock"></i></button>
																		}
																		{ (selected && showReconciliationButton) &&
																			<button className="btn-unstyled" onClick={() => setReconciliationModalOpened(true)}><i className="bi bi-arrow-up-circle-fill"></i></button>
																		}
																	</td>

																	{ (!value.reconciliation || value.reconciliation.length === 0) ? // Can select to reconciliate
																		<React.Fragment>
																			<td onClick={(e) => position === 'right' ? selectMovement(value) : e.preventDefault()}>
																				{ position === 'right' &&
																					moment(value.date).format('DD-MM-YYYY')
																				}
																			</td>
																			<td onClick={(e) => position === 'right' ? selectMovement(value) : e.preventDefault()}>
																				{ position === 'right' &&
																					<React.Fragment>
																						<span onClick={(e) => openEntity(e, value)} className={'badge ' + value.concept_color}>{value.concept_type}</span>
																						&nbsp;
																						{(value.class.indexOf('ProviderInvoice') !== -1 && !value.accounted) &&
																							<span className="badge badge-rounded bg-danger me-2">&nbsp;</span>
																						}
																						{value.concept}
																					</React.Fragment>
																				}
																			</td>
																			<td className={value.amount < 0 ? 'red' : 'green'} onClick={(e) => position === 'right' ? selectMovement(movementsRow.key, movement.key) : e.preventDefault()}>
																				{ position === 'right' &&
																					formatNumber(value.amount)
																				}
																			</td>
																		</React.Fragment>
																		: // Is reconciliated
																		<React.Fragment>
																			<td onClick={(e) => partial ? selectMovement(value.reconciliation[0].entity) : e.preventDefault()}>{moment(value.reconciliation[0].entity.date).format('DD-MM-YYYY')}</td>
																			<td onClick={(e) => partial ? selectMovement(value.reconciliation[0].entity) : e.preventDefault()} className="p-0">
																				<div className="reconciliations">
																					{ value.reconciliation.map((reconciliation, reconciliationIdx) => {
																						return (
																							<div 
																								key={reconciliationIdx}
																								onClick={(e) => partial ? selectMovement(reconciliation.entity) : e.preventDefault()}
																								data-heightfixfrom={value.id + '|' + reconciliationIdx}
																							>
																								<span className={'badge ' + reconciliation.entity.concept_color} onClick={(e) => openEntity(e, reconciliation.entity, value)}>{reconciliation.entity.concept_type}</span>&nbsp;
																								{(reconciliation.entity.class.indexOf('ProviderInvoice') !== -1 && !reconciliation.entity.accounted) &&
																									<span className="badge badge-rounded bg-danger me-2">&nbsp;</span>
																								}
																								{reconciliation.entity.concept ?? '-'}
																								{reconciliation.entity.class.indexOf('ProviderInvoice') !== -1 &&
																									<div className="providerinvoice-counterparts">
																										{reconciliation.entity.counterparts.map((counterpart, counterpartIdx) => {
																											return (
																												<div key={'pi' + reconciliation.entity.id + '-' + counterpartIdx}>
																													{counterpart.name}
																													<span className="providerinvoice-counterparts-amount">{formatNumber(counterpart.amount)}</span>
																												</div>
																											);
																										})}
																									</div>
																								}
																								{reconciliation.entity.parent_receipt &&
																									<div className="receiptrefund-parent">
																										Nuevo recibo generado <i className="bi bi-arrow-right"></i> {reconciliation.entity.parent_receipt.number_full}
																									</div>
																								}
																								{ 
																									(
																										reconciliation.entity.class.indexOf('EstimateGroupExpense') !== -1
																										&&
																										reconciliation.entity.text
																									) &&
																									<div className="small-text">{reconciliation.entity.text}</div>
																								}
																							</div>
																						)
																					})}
																				</div>
																			</td>
																			<td onClick={(e) => partial ? selectMovement(value.reconciliation[0].entity) : e.preventDefault()} className="p-0">
																				<div className="reconciliations">
																					{ value.reconciliation.map((reconciliation, reconciliationIdx) => {
																						return (
																							<div 
																								key={reconciliationIdx} 
																								onClick={(e) => partial ? selectMovement(reconciliation.entity) : e.preventDefault()}
																								className={value.amount < 0 ? 'red' : 'green'}
																								data-heightfixto={value.id + '|' + reconciliationIdx}
																							>
																								{formatNumber(reconciliation.entity.amount)}
																							</div>
																						)
																					})}
																				</div>
																			</td>
																		</React.Fragment>
																	}
																</tr>
															);
														})}
													</React.Fragment>
												);
											})
										})() }

										{ loadingMovements && <TrSkeleton rows={skeletonRows} columns={8} /> }
										{ (!loadingMovements && movements && !Object.keys(movements).length) && <tr><td colSpan="100%">No hay datos disponibles</td></tr> }
									</tbody>
								</Table>
							</div>
						</div>
						{/* <div className="card-footer p-3 d-flex justify-content-end" id={popup ? 'footer-fixed' : ''}>
							<div className="d-inline-block">
								
							</div>
						</div> */}
					</div>
				</div>
				{ showReconciliationButton && 
					<ButtonReconciliation className="btn btn-primary" onClick={() => setReconciliationModalOpened(true)}>
						<i className="bi bi-arrow-left-right"></i>
						Conciliar movimientos seleccionados
					</ButtonReconciliation>
				}
			</section>

			{ reconciliationModalOpened && 
				<ReconciliationModal 
					movements={selectedMovements}
					closeCallback={(unselectSelectedMovements, showSkeletonOnReload, additionalDates = []) => {
						if ( unselectSelectedMovements ) setSelectedMovements([]);
						// if ( showSkeletonOnReload ) setMovements(undefined);

						// setForceReload(Math.random());
						let dates = selectedMovements.map(item => item.date);
						dates = [...dates, ...additionalDates];
						refreshRowsFromDates(dates);

						setReconciliationModalOpened(false);
					}}
				/>
			}

			{ counterPartModalOpened && 
				<CounterPartsModal 
					data={counterPartModalOpened}
					closeCallback={(datesToUpdate) => {
						let dates = [...datesToUpdate, counterPartModalOpened.date];
						refreshRowsFromDates(dates);

						setCounterPartModalOpened(false);
					}}
				/>
			}

			{ addManualMovementModalOpened &&
				<AddManualMovementModal 
					treasuryId={treasury?.id}
					onClose={(affectedDates) => {
						setAddManualMovementModalOpened(false);
						refreshRowsFromDates(affectedDates);
					}}
				/>
			}
		</Layout>
	);
}